module.exports = __webpack_public_path__ + "static/media/Reindeer Costume.643003d9.jpg";